// The street picture on screen: the current look's four tiles and the flower-bed foreground copied from them,
// crossfading into the next look when the phase changes (render/phasedLook.js).
import { createPhasedLook } from '../render/phasedLook.js';
import { applyForeground } from '../scenes/sceneForeground.js';
import { STREET_LOOKS, lookFor, nextLook, streetTileKeys, streetTileRects } from './streetLooks.mjs';

export function createStreetLook(scene, { phase }) {
  return createPhasedLook(scene, {
    phase,
    looks: STREET_LOOKS,
    lookFor,
    layersFor: streetTileRects,
    foregroundFor: (look, tiles) => applyForeground(scene, 'street', null, { tiles }),
    prefetch: (look) => streetTileKeys(nextLook(look)),
  });
}
